import { PageComponent, PageState } from "barba"

const USER_HEIGHT = 'user-height'
const ADJUSTMENT_CHECKED = 'bike-geometry-adjustment-checked'

class BikeGeometryClass {

    constructor({ node }) {
        this.node = node
        this.heightSelect = this.node.querySelector('.form-select')
        this.adjustementCheckbox = this.node.querySelector('.bike-geometry__check-input')
        this.frame = this.node.querySelector('.bike-geometry__frame')
        this.table = this.node.querySelector('.bike-geometry__table')
        this.tableRows = this.node.querySelectorAll('.bike-geometry__table-tr')
        this.userHeight = this.getDefaultUserHeight()
        this.smallest = this.getSmallestSize()
        this.largest = this.getLargestSize()

        this.updateHeightHandler = this.updateHeight.bind(this)
        this.updateAdjustmentHandler = this.updateAdjustment.bind(this)
        this.updateMaxHeightHandler = this.updateMaxHeight.bind(this)
        this.mouseEnterRowHandler = this.mouseEnterRow.bind(this)
        this.mouseLeaveRowHandler = this.mouseLeaveRow.bind(this)

        this.heightSelect.addEventListener('change', this.updateHeightHandler)
        this.tableRows.forEach(x => x.addEventListener('mouseenter', this.mouseEnterRowHandler))
        this.tableRows.forEach(x => x.addEventListener('mouseleave', this.mouseLeaveRowHandler))
        window.addEventListener("resize", this.updateMaxHeightHandler)

        if (this.adjustementCheckbox) {
            if (PageState.get(ADJUSTMENT_CHECKED) !== null) {
                this.adjustementCheckbox.checked = PageState.get(ADJUSTMENT_CHECKED)
            }
            this.adjustementCheckbox.addEventListener('change', this.updateAdjustmentHandler)
        }
        
        if (this.userHeight !== null) {
            this.heightSelect.value = this.userHeight
        }
    
        this.updateTable()
        this.updateMaxHeight()
        
        this.frame.style.setProperty('--bike-geometry-frame-height', 'auto')
    }

    updateHeight() {
        localStorage.setItem(USER_HEIGHT, this.heightSelect.value)
        this.userHeight = this.heightSelect.value
        this.updateTable()
        this.updateMaxHeight()
    }

    updateAdjustment() {
        if (!this.adjustementCheckbox) {
            return
        }
        PageState.set(ADJUSTMENT_CHECKED, this.adjustementCheckbox.checked)

        this.updateTable()
    }

    updateMaxHeight() {
        window.requestAnimationFrame(() => !this.frame || this.frame.style.setProperty('--bike-geometry-frame-max-height', `${this.frame.scrollHeight}px`))
    }

    updateTable() {
        let adjustementSelector = `[data-adjustment]`

        // Hide all
        this.table.querySelectorAll(adjustementSelector).forEach(x => x.classList.add('hidden'))
        this.table.querySelectorAll(adjustementSelector).forEach(x => x.classList.remove('bike-geometry__cell-selected'))

        // Show matching adjustement within min / max
        if (this.adjustementCheckbox) {
            adjustementSelector = `[data-adjustment="${this.adjustementCheckbox.value}"]`
            if (!this.adjustementCheckbox.checked) {
                adjustementSelector = `:not(${adjustementSelector})`
            }
        }

        
        this.table.querySelectorAll(adjustementSelector).forEach(x => {
            x.classList.remove('hidden')
            if (this.sizeMatchesUserHeight(
                parseInt(x.dataset.min), 
                parseInt(x.dataset.max)
            )) {
                x.classList.add('bike-geometry__cell-selected')
            }
        })

        /* Scroll to selected element on mobile */
        if (this.userHeight !== null) {
            if (this.table.offsetWidth > window.innerWidth) {
                const rowTitleWidth = this.table.querySelector('.bike-geometry__table-td--row-title').offsetWidth;
                const cellLeftPos = this.table.querySelector('.bike-geometry__cell-selected').getBoundingClientRect().left;
                const leftScrollPos = this.table.parentNode.scrollLeft

                this.table.parentNode.scrollTo({
                    top: 0,
                    left: (cellLeftPos + leftScrollPos) - rowTitleWidth,
                    behavior: 'smooth'
                });    
            }
        }
        
    }
    
    sizeMatchesUserHeight(min, max) {
        if (this.userHeight === null) return false;
        
        const userHeight = parseInt(this.userHeight);
        
        if (min === this.smallest && userHeight <= this.smallest) return true;
        if (max === this.largest && userHeight >= this.largest) return true;
        
        // Note: modifié de 2 à 0 dans la tâche DV-8
        // Le nouvel affichage fait en sorte qu'il n'est plus nécessaire 
        // de sélectionner les tailles "proches" de la taille sélectionnée
        const fuzzyFactor = 0;
        min -= fuzzyFactor;
        max += fuzzyFactor;
        
        return userHeight >= min && userHeight <= max;
    }

    getSmallestSize() {
        let smallest = 9999;

        this.table.querySelectorAll("[data-adjustment]").forEach(x => {
            const min = parseInt(x.dataset.min);
            if (min < smallest)
                smallest = min;
        })

        return smallest;
    }

    getLargestSize() {
        let largest = 0;

        this.table.querySelectorAll("[data-adjustment]").forEach(x => {
            const max = parseInt(x.dataset.max);
            if (max > largest)
                largest = max;
        })

        return largest;
    }

    mouseEnterRow(e) {
        const id = e.target.dataset.pictureId
        if (!id) {
            return
        }
        const element = this.node.querySelector(`#${id}`);
        if (element) {
            element.classList.remove('hidden')
        }
    }

    mouseLeaveRow(e) {
        const id = e.target.dataset.pictureId
        if (!id) {
            return
        }
        const element = this.node.querySelector(`#${id}`);
        if (element) {
            element.classList.add('hidden')
        }
    }

    getDefaultUserHeight() {
        const userHeight = localStorage.getItem(USER_HEIGHT)
        const selectOptions = this.heightSelect.options
        if (userHeight === null) {
            return null
        }
        for (let i = 0; i < selectOptions.length; i++) {
            if (selectOptions[i].value === userHeight) {
                return userHeight
            }
        }
        return null
    }

    destroy() {
        this.heightSelect.removeEventListener('change', this.updateHeightHandler)
        this.tableRows.forEach(x => x.removeEventListener('mouseenter', this.mouseEnterRowHandler))
        this.tableRows.forEach(x => x.removeEventListener('mouseleave', this.mouseLeaveRowHandler))
        window.removeEventListener("resize", this.updateMaxHeightHandler)

        if (this.adjustementCheckbox) {
            this.adjustementCheckbox.removeEventListener('change', this.updateAdjustmentHandler)
        }

        delete this.updateHeightHandler
        delete this.updateAdjustmentHandler
        delete this.updateMaxHeightHandler
        delete this.mouseEnterRowHandler
        delete this.mouseLeaveRowHandler

        delete this.node
        delete this.heightSelect
        delete this.adjustementCheckbox
        delete this.frame
        delete this.table
        delete this.tableRows
        delete this.userHeight
        delete this.smallest
        delete this.largest
    }

}

new PageComponent(".bike-geometry", BikeGeometryClass)